import React from 'react';
import './output.css';
import Header from './feacture/header/Header'
import Hero from "./feacture/hero/Hero";
import About from './feacture/About/About';
import Footer from './feacture/Footer/Footer';
import "@fortawesome/fontawesome-free/css/all.css";
import ExtraComp from './feacture/ExtraComp/ExtraComp';
import AllFeatures from './feacture/AllFeatures/AllFeatures';
import Reports from './feacture/Reports/Reports';
import MainSecond from './feacture/secModule/MainSecond';
import FaqComponent from './feacture/FAQ/FAQ';
import Contact from './feacture/Contact/Contact';
import Anylise from './feacture/Anylise/Anylise';
import Verification from './feacture/Verification/Verification';
import Comp from './feacture/TdsComp/Comp';
import Ofm from './feacture/OMU/Ofm';
import SecExtra from './feacture/ExtraComp/SecExtra';
import FeatureVideo from './feacture/FeatureVideo/FeatureVideo';
import ThirdExtra from './feacture/ExtraComp/ThirdExtra';

function App() {
  
  return (
    <>
      <Header />
      <Hero />
      <FeatureVideo />
      <AllFeatures />
      <Reports />
      <Comp />
      <ExtraComp />
      <Anylise />
      <MainSecond />
      <Verification />
      <SecExtra />
      <Ofm />
      <About />
      <Contact />
      <FaqComponent />
      <ThirdExtra />
      <Footer />
    </>
  );
}

export default App;
